var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary btn-create",
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#carouselModal",
          },
          on: {
            click: function ($event) {
              return _vm.carouselModal({ action: "add" })
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "sort",
                fn: function (scope) {
                  return [
                    _c("div", { staticClass: "text-center" }, [
                      scope.row.id !== 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              staticStyle: { margin: "0 2px" },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort(scope.row.Guid, "up")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-up",
                              }),
                            ]
                          )
                        : _vm._e(),
                      scope.row.id !== _vm.rows.length
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-secondary btn-sm",
                              staticStyle: { margin: "0 2px" },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeSort(scope.row.Guid, "down")
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fas fa-long-arrow-alt-down",
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                },
              },
              {
                key: "edit",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        staticStyle: { "margin-right": "0.5rem" },
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#carouselModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.carouselModal({
                              action: "edit",
                              data: scope.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "delete",
                fn: function (scope) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#delModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.banner = scope.row
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "carouselModal",
          tabindex: "-1",
          "aria-hidden": "true",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered modal-lg" },
          [
            _c("ValidationObserver", {
              ref: "carousel",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "modal-content" },
                            [
                              _c("div", { staticClass: "modal-header" }, [
                                _c("span", { staticClass: "modal-title" }, [
                                  _vm.action === "add"
                                    ? _c("span", [_vm._v("新增")])
                                    : _c("span", [_vm._v("編輯")]),
                                ]),
                              ]),
                              _c(
                                "perfect-scrollbar",
                                { staticClass: "modal-body" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      attrs: {
                                                        for: "input-banner-name",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v(" 名稱 "),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.banner.BannerName,
                                                        expression:
                                                          "banner.BannerName",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      id: "input-banner-name",
                                                      maxlength: "50",
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.banner.BannerName,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.banner,
                                                          "BannerName",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "BannerPic",
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("電腦版圖片"),
                                                    ]
                                                  ),
                                                  _vm.computerPic
                                                    ? _c("img", {
                                                        staticClass:
                                                          "form-control",
                                                        staticStyle: {
                                                          height: "400px",
                                                          "margin-bottom":
                                                            "10px",
                                                        },
                                                        attrs: {
                                                          src: _vm.computerPic,
                                                          alt: "",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "10px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            " * 檔案限制：[檔名].jpg、[檔名].png "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 大小限制：5MB以下"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 僅能選取一個檔案"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 上傳前請確認是否符合格式"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      ref: "uploadComputer",
                                                      staticClass:
                                                        "upload-demo",
                                                      attrs: {
                                                        action: "",
                                                        accept:
                                                          "image/jpeg,image/png",
                                                        limit: 1,
                                                        "auto-upload": false,
                                                        "list-type": "picture",
                                                        "on-change":
                                                          _vm.uploadFile,
                                                        "on-remove":
                                                          _vm.removeFile,
                                                        "file-list":
                                                          _vm.computerList,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.banner.BannerPic,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.banner,
                                                            "BannerPic",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "banner.BannerPic",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "small",
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.uploadType =
                                                                "computer"
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" 點擊上傳 ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "BannerPicMobile",
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    { attrs: { for: "" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("手機版圖片"),
                                                    ]
                                                  ),
                                                  _vm.mobilePic
                                                    ? _c("img", {
                                                        staticClass:
                                                          "form-control",
                                                        staticStyle: {
                                                          height: "400px",
                                                          "margin-bottom":
                                                            "10px",
                                                        },
                                                        attrs: {
                                                          src: _vm.mobilePic,
                                                          alt: "",
                                                        },
                                                      })
                                                    : _vm._e(),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "10px",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            " * 檔案限制：[檔名].jpg、[檔名].png "
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 大小限制：5MB以下"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 僅能選取一個檔案"
                                                          ),
                                                        ]
                                                      ),
                                                      _c("br"),
                                                      _c(
                                                        "span",
                                                        { staticClass: "mark" },
                                                        [
                                                          _vm._v(
                                                            "* 上傳前請確認是否符合格式"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "el-upload",
                                                    {
                                                      ref: "uploadMobile",
                                                      staticClass:
                                                        "upload-demo",
                                                      attrs: {
                                                        action: "",
                                                        accept:
                                                          "image/jpeg,image/png",
                                                        limit: 1,
                                                        "auto-upload": false,
                                                        "list-type": "picture",
                                                        "on-change":
                                                          _vm.uploadFile,
                                                        "on-remove":
                                                          _vm.removeFile,
                                                        "file-list":
                                                          _vm.mobileList,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.banner
                                                            .BannerPicMobile,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.banner,
                                                            "BannerPicMobile",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "banner.BannerPicMobile",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "el-button",
                                                        {
                                                          attrs: {
                                                            size: "small",
                                                            type: "primary",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.uploadType =
                                                                "mobile"
                                                            },
                                                          },
                                                        },
                                                        [_vm._v(" 點擊上傳 ")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  errors[0]
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "text-danger",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                errors[0]
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c("div", { staticClass: "modal-footer" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-secondary",
                                    attrs: {
                                      type: "button",
                                      "data-dismiss": "modal",
                                    },
                                    on: {
                                      click: function ($event) {
                                        _vm.$refs.uploadComputer.clearFiles(),
                                          _vm.$refs.uploadMobile.clearFiles()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Cancel")) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return handleSubmit(_vm.saveCarousel)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.i18n("Buttons.Save")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: { id: "delModal", tabindex: "-1", "data-backdrop": "static" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [_vm._v("刪除")]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.banner.BannerName) + " ")]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delCarousel },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }